import { MAX_VIN_CODE_LENGTH, VIN_CODE_REGEX } from '../common/constants/vinCode';

export const validateVinCode = (vin, t) => {
    if (!vin) {
        return t('profile:form.vinValidation.required');
    }
    if (vin.length !== MAX_VIN_CODE_LENGTH) {
        return `${t('profile:form.vinValidation.this-vin-code')} ${vin} ${t('profile:form.vinValidation.should-be')} ${MAX_VIN_CODE_LENGTH} ${t('profile:form.vinValidation.characters-long')}`;
    }
    if (!VIN_CODE_REGEX.test(vin)) {
        return `${t('profile:form.vinValidation.this-vin-code')} ${vin} ${t('profile:form.vinValidation.contains-invalid-characters-or-is-malformed')}`;
    }
    return '';
};
